import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";

const SettingsOffCanvas = () => {
  const [openModal, setOpenModal] = useState(false);

  const [grayScale, setGrayScale] = useState(false);
  const [invertPage, setInvertPage] = useState(false);
  const [increaseFont, setIncreaseFont] = useState(0);

  const onHide = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    if (grayScale) {
      document.body.classList.add("grayscale");
    } else {
      document.body.classList.remove("grayscale");
    }

    // Cleanup function to remove the class on component unmount
    return () => {
      document.body.classList.remove("grayscale");
    };
  }, [grayScale]);

  useEffect(() => {
    if (invertPage) {
      document.body.classList.add("negative-page");
    } else {
      document.body.classList.remove("negative-page");
    }

    // Cleanup function to remove the class on component unmount
    return () => {
      document.body.classList.remove("negative-page");
    };
  }, [invertPage]);

  useEffect(() => {
    if (increaseFont == 1) {
      document.body.classList.add("font-size-105");
    } else if (increaseFont == 2) {
      document.body.classList.add("font-size-108");
    } else if (increaseFont == 3) {
      document.body.classList.add("font-size-110");
    } else if (increaseFont >= 4) {
      document.body.classList.add("font-size-112");
    }

    if (increaseFont == 0) {
      document.body.classList.remove("font-size-105");
      document.body.classList.remove("font-size-108");
      document.body.classList.remove("font-size-110");
      document.body.classList.remove("font-size-112");
    }
    // Cleanup function to remove the class on component unmount
    return () => {
      document.body.classList.remove("font-size-105");
      document.body.classList.remove("font-size-108");
      document.body.classList.remove("font-size-110");
      document.body.classList.remove("font-size-112");
    };
  }, [increaseFont]);

  const handleFontIncreaseClick = () => {
    if (increaseFont < 4) setIncreaseFont(increaseFont + 1);
  };
  const handleFontDecreaseClick = () => {
    if (increaseFont > 0) setIncreaseFont(increaseFont - 1);
  };

  const resetAll = () => {
    setIncreaseFont(0);
    setGrayScale(false);
    setOpenModal(false);
  };

  return (
    <div>
      <a
        onClick={() => setOpenModal(true)}
        className="text-white btn-lg-square back-to-top-gallery"
      >
        <i className="fa-brands fa-accessible-icon"></i>
      </a>

      <Offcanvas
        show={openModal}
        onHide={(e) => setOpenModal(false)}
        placement="end"
        className="site_settings_canvas"
      >
        <Offcanvas.Header closeButton className="py-2 fw-bold">
          <Offcanvas.Title>Screen Reading Tools</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul>
            <li className="pb-2">
              <a href="javascript:;" onClick={(e) => handleFontIncreaseClick()}>
                <i className="fa-solid fa-plus me-2"></i>Increase Text
              </a>
            </li>
            <li className="pb-2">
              <a href="javascript:;" onClick={(e) => handleFontDecreaseClick()}>
                <i className="fa-solid fa-minus me-2"></i>Decrease Text
              </a>
            </li>
            {/*<li className="pb-2">
              <a
                href="javascript:;"
                onClick={(e) => setInvertPage(!invertPage)}
              >
                <i className="fa-solid fa-eye me-2"></i>Negative Content
              </a>
            </li>*/}
            <li className="pb-2">
              <a href="javascript:;" onClick={(e) => setGrayScale(!grayScale)}>
                <i className="fa-solid fa-barcode me-2"></i>Grayscale
              </a>
            </li>
            <li>
              <a href="javascript:;" onClick={(e) => resetAll()}>
                <i className="fa-solid fa-xmark me-2"></i>Reset
              </a>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default SettingsOffCanvas;
